export const SubjectCard = ({ name, image }) => (
  <div className="subject-card">
    <img src={image} alt={name} className="subject-image" />
    <div className="subject-name">{name}</div>
  </div>
);
